export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://collabdevs-backend.onrender.com"
    : "http://localhost:8000";
